import { UserHierarchyLevel } from '@practium/shared';
import type { RouteConfig } from '@practium/shared';
import type { SidebarConfig } from '@practium/ui';
import {
	HomeIcon,
	DashboardIcon,
	FloraIcon,
	PlantIcon,
	UsersIcon,
	ProductsIcon,
	MyPlanIcon,
	ContactIcon,
	SettingsIcon,
	LogOutIcon,
	PropertiesIcon,
	FarmersIcon,
	ConsultantsIcon,
	SidebarClipboardIcon,
	FileChartIcon,
	SidebarFileCheckIcon,
	MicroscopeIcon,
	TableIcon,
	FieldDiaryIcon,
} from '@practium/ui';
import { JSX } from 'react';

const ICON_MAP: Record<string, JSX.Element> = {
	home: <HomeIcon />,
	dashboard: <DashboardIcon />,
	flora: <FloraIcon />,
	plant: <PlantIcon />,
	clipboard: <SidebarClipboardIcon />,
	fileCheck: <SidebarFileCheckIcon />,
	properties: <PropertiesIcon />,
	users: <UsersIcon />,
	consultant: <ConsultantsIcon />,
	farmer: <FarmersIcon />,
	products: <ProductsIcon />,
	myPlan: <MyPlanIcon />,
	contact: <ContactIcon />,
	settings: <SettingsIcon />,
	logout: <LogOutIcon />,
	fileChart: <FileChartIcon />,
	microscope: <MicroscopeIcon />,
	suport: <ContactIcon />,
	parcelling: <TableIcon />,
	fieldDiary: <FieldDiaryIcon />,
};

interface PromotionConfig {
	text: string;
	buttonLabel: string;
	onButtonClick: () => void;
}

const DEFAULT_PROMOTION: PromotionConfig = {
	text: 'Desbloqueie Todo o Potencial do Practium',
	buttonLabel: 'Saber Mais',
	onButtonClick: () => {},
};

const PROMOTIONS: Record<UserHierarchyLevel, PromotionConfig | undefined> = {
	[UserHierarchyLevel.Farmer]: DEFAULT_PROMOTION,
	[UserHierarchyLevel.Consultant]: DEFAULT_PROMOTION,
	[UserHierarchyLevel.Company]: DEFAULT_PROMOTION,
	[UserHierarchyLevel.Master]: undefined,
};

export const buildSidebarConfig = (
	userLevel: UserHierarchyLevel,
	routes: RouteConfig[]
): SidebarConfig => {
	const mainRoutes = routes
		.filter((route) => route.path !== '/perfil')
		.map((route) => ({
			path: route.path,
			label: route.label,
			icon: route.icon && ICON_MAP[route.icon] ? ICON_MAP[route.icon] : <HomeIcon />,
		}));

	return {
		mainRoutes,
		footerRoutes: [
			{ path: '/perfil', label: 'Preferências', icon: <SettingsIcon /> },
			{ path: '/logout', label: 'Logout', icon: <LogOutIcon /> },
		],
		promotion: PROMOTIONS[userLevel],
	};
};
